module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAARgAAABUBAMAAACrTTUcAAAAJFBMVEUAAACfn5+ampqYmJiZmZmXl5eZmZmYmJiZmZmZmZmampqZmZmwkqmiAAAAC3RSTlMAEM/Q8GAyoK+Abxl/pC0AAADZSURBVGje7dohDsJAGEThv4ISXBNO0HPgMTX1NYgeoJ5bNRAIezl2XSEZ2x3x3gm+jJ5IdXvcYlOq3PUHE1U7ptEHE/enEeaURh9MTB8jzCEtPpiYXkaYdlh8MDG/Ox9MO/Q+mJjXzgfTXHofTJzXzgeTp/HBlGl8MHkaH0yZxgeTp/HBlGl8MHkaH0yZxgeTp/HB5GmMME0ywgQYMGDA/AVGBUYFRgVGBUYFRgVGBUYFRgVGBUYFRgVGBUYFRgVGBUYFRgVGBUYFRgVGBUYFZrdS9XPyJi/MF9tI/lTTPUrlAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/partner/detail-type.png
// module id = Bkd4
// module chunks = 0